module.exports = {"610603001":"真武洞街道","610603002":"金明街道","610603003":"白坪街道","610603101":"砖窑湾镇","610603102":"沿河湾镇","610603103":"招安镇","610603104":"化子坪镇","610603105":"坪桥镇","610603106":"建华镇","610603107":"高桥镇","610603108":"镰刀湾镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610603.json
// module id = 2834
// module chunks = 0